import react from "react";
import { SectionCard } from "../../../Component/CustComponents/SectionCard";
import { Mail, MessageCircle, Phone } from "lucide-react";

export default function SupportView() {
  return (
    
      <div className="space-y-4 p-2">
      <SectionCard title="Need Help?">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
          <div className="border border-slate-100 rounded-xl p-3 bg-slate-50/80 flex flex-col gap-2">
            <div className="font-semibold text-slate-800 flex items-center gap-2">
              <Phone className="w-4 h-4 text-blue-600" />
              <span>Call Support</span>
            </div>
            <p className="text-slate-600">
              For urgent device issues or visit requests, talk to our support
              team.
            </p>
            <div className="mt-1 font-semibold text-slate-800">
              +91 1800-123-456
            </div>
            <p className="text-[11px] text-slate-500">Mon–Sat, 9:30am–7:00pm</p>
          </div>

          <div className="border border-slate-100 rounded-xl p-3 bg-slate-50/80 flex flex-col gap-2">
            <div className="font-semibold text-slate-800 flex items-center gap-2">
              <Mail className="w-4 h-4 text-blue-600" />
              <span>Email</span>
            </div>
            <p className="text-slate-600">
              Share logs, photos or detailed description over email.
            </p>
            <div className="mt-1 font-semibold text-slate-800">
              support@goelectronix.com
            </div>
            <p className="text-[11px] text-slate-500">
              We usually respond within 24 hours.
            </p>
          </div>

          <div className="border border-slate-100 rounded-xl p-3 bg-slate-50/80 flex flex-col gap-2">
            <div className="font-semibold text-slate-800 flex items-center gap-2">
              <MessageCircle className="w-4 h-4 text-blue-600" />
              <span>WhatsApp</span>
            </div>
            <p className="text-slate-600">
              Chat with us, share device photos and track your claim updates.
            </p>
            <div className="mt-1 font-semibold text-slate-800">
              +91 98765 99999
            </div>
            <p className="text-[11px] text-slate-500">
              Available 7 days, 8:00am–10:00pm
            </p>
          </div>
        </div>
      </SectionCard>

      <SectionCard title="Tips for Faster Resolution">
        <ul className="list-disc list-inside text-xs text-slate-600 space-y-1">
          <li>Always keep your device, charger and cable ready for testing.</li>
          <li>Mention any error messages or beeps you see/hear.</li>
          <li>
            If device was exposed to water or physical shock, inform the
            engineer honestly.
          </li>
          <li>
            For on-site visits, ensure someone is available at the address
            during the confirmed slot.
          </li>
        </ul>
      </SectionCard>
    </div>
    
  );
}